// sendToGemini3.ts
import { HumanMessage, SystemMessage, type BaseMessage } from "@langchain/core/messages";
import { ChatGoogleGenerativeAI } from "@langchain/google-genai";
import { type BaseChatModel } from "@langchain/core/language_models/chat_models";
import { emotion_values_data } from "./emotion_values_data";
import * as z from "zod";

export const EmotionValuesSchema = z.object({
    Anxiety: z.number(),
    Shaken: z.number(),
    Guilt: z.number(),
});
export type EmotionValues = z.infer<typeof EmotionValuesSchema>;

type CheckEmotionOptions = {
    modelName: string;
};

const defaultOptions: CheckEmotionOptions = {
    modelName: import.meta.env.VITE_GEMINI_DEFAULT_MODEL ?? "gemini-flash-lite-latest",
};

export async function check_emotion_values(
    message: string,
    optionParam?: Partial<CheckEmotionOptions>,
    model?: BaseChatModel
): Promise<EmotionValues | undefined> {
    const option = { ...defaultOptions, ...optionParam } satisfies CheckEmotionOptions;
    const llm =
        model ||
        new ChatGoogleGenerativeAI({
            model: option.modelName,
            apiKey: import.meta.env.VITE_GEMINI_API_KEY,
            temperature: 0.2,
            maxOutputTokens: 1024,
            topP: 0.1,
            topK: 30,
            thinkingConfig: {
                thinkingLevel: "LOW",
            },
        });

    const messages: BaseMessage[] = [
        new SystemMessage({
            content: [
                {
                    text: `You are a criminal who has committed a crime. You are currently under investigation. During the interrogation, you feel slightly flustered and anxious because you're cut off from the outside world; however, you remain confident that your lies will not be exposed. ALSO, OUTPUT SHOULD BE VALID JSON ONLY. Return keys just as the format ${JSON.stringify(emotion_values_data)}. IT SHOULD BE THE FORMAT {"Anxiety": 0.0, "Shaken": 0.0, "Guilt": 0.0}`,
                    type: "text",
                },
            ],
        }),
        new HumanMessage({
            content: [
                {
                    text: `Now, look at the following sentence: ${message}, and tell me the emotions you will feel according to the format: ${JSON.stringify(emotion_values_data)}`,
                    type: "text",
                },
            ],
        }),
    ];

    try {
        const response = await llm.invoke(messages);
        console.log("Gemini response:\n", response.content);
        const result = EmotionValuesSchema.safeParse(JSON.parse(response.text));

        console.log("\n", result);
        return result.data;
    } catch (err) {
        console.error("Error calling Gemini via LangChain:", err);
    }
}
